import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ModalDialog,
} from '../../common';

import './UpdatePaymentMethodModal.css';

const UpdatePaymentMethodModal = ({
  onClose = () => { },
  show = false,
}) => {
  const { t } = useTranslation('insurance');

  const handleOnPress = useCallback(() => {
    if (show) {
      onClose();
    }
  }, [onClose, show]);

  return (
    <ModalDialog
      onClose={handleOnPress}
      show={show}
    >
      <div className="Update-payment-method-modal-container">
        <h1>{t('updatePaymentMethod.title')}</h1>

        <span>{t('updatePaymentMethod.description')}</span>

        <button
          className="Update-payment-method-modal-container-button"
          onClick={handleOnPress}
          type="button"
        >
          {t('updatePaymentMethod.button')}
        </button>
      </div>
    </ModalDialog>
  );
};

export { UpdatePaymentMethodModal };
